/**
 * Created by Pavel on 15/03/2016.
 */

    require ('buyinvite/logo.gif');


/** WEBPACK FOOTER **
 ** ./index.js
 **/